import { SettingsLayout } from 'views/settings';
import { AlertFilteringIndicator } from '_components/indicators';
import { getIcons } from '_helpers';
import { useNavigate } from 'react-router-dom';
import { AlertsTableReport } from './tables/Alerts.Table.Report';
import { SidePanel } from '_components';

export { AlertsList };

function AlertsList() {

    const navigate = useNavigate();

    return (
        <div>
            <SettingsLayout />
            <div className='px-8'>
                <div className='flex justify-between w-full mb-4'>
                    <AlertFilteringIndicator />
                    <div className='flex items-center'>
                        <button className='btn-custom btn-custom-primary' onClick={() => navigate('/alertes/gestion')}>
                            <img src={getIcons('warningAmberOutlined')} className='btn-custom-icon mt-[-4px]' alt='manage alerts' />
                            Gérer les pré-alertes
                        </button>
                    </div>
                </div>                
                <AlertsTableReport limit={false} maxHeight={'70vh'}/>
            </div>
            <SidePanel />
        </div>
        
    );
}